import { LandingMediaDropbox } from './MediaDropBox';
import { FieldTitle } from './RedStarTitle';
import { faImage, faVideo } from '@fortawesome/pro-regular-svg-icons';
import {
  useFormContext,
  Controller,
  UseFormRegisterReturn,
} from 'react-hook-form';
import { TextField } from '@client/new/components/basic';
import { FieldDesc } from './common';
import { BulletsInput } from './BulletsInput';
import { SelectImageSideInput } from './SelectImageSide';
import { TwoColumns } from './layouts';

type Props = {
  imageUpload: (file: File) => Promise<string>;
  videoUpload: (file: File) => Promise<string>;
  register: (s: string) => UseFormRegisterReturn;
  index: number;
};
export function TextSection1({
  imageUpload,
  videoUpload,
  register: r,
  index,
}: Props) {
  const { control } = useFormContext();

  const MAX_DESC_LENGTH = 1000;

  const firstCol = (
    <>
      <div>
        <FieldTitle title={'Headline text'} />
        <div className="mb-[5px] max-w-[680px]">
          <TextField
            {...r(`title`)}
            className="w-full"
            inputProps={{
              placeholder: 'Headline text',
              maxLength: 60,
            }}
          />
        </div>
      </div>

      <div>
        <FieldTitle title={'Body Text'} optional />
        <FieldDesc>
          Body Text (new lines are preserved, max {MAX_DESC_LENGTH} characters)
        </FieldDesc>
        <div className="mb-[5px] max-w-[680px] w-full">
          <TextField
            {...r(`desc`)}
            multiline
            rows={5}
            className="w-full"
            inputProps={{
              style: { height: '200px' },
              maxLength: MAX_DESC_LENGTH,
            }}
          />
        </div>
      </div>

      <div>
        <div>
          <FieldTitle title={'Bullets'} optional />
        </div>
        <BulletsInput name={`sections.${index}.bullets`} />
      </div>
    </>
  );

  const coverImageInput = (
    <Controller
      name={`sections.${index}.coverImage`}
      control={control}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <LandingMediaDropbox
          inputRef={ref}
          width="260px"
          height="260px"
          upload={imageUpload}
          label="Image"
          validationText=""
          value={value}
          onChange={onChange}
          type="image"
          icon={faImage as any}
          errorMsg={error?.message}
        >
          <ul className="text-black list-none text-center text-h12">
            <li>Square image/gif, max 5MB</li>
          </ul>
        </LandingMediaDropbox>
      )}
    />
  );

  const introVideoInput = (
    <Controller
      name={`sections.${index}.introVideo`}
      control={control}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <LandingMediaDropbox
          inputRef={ref}
          width="260px"
          height="260px"
          upload={videoUpload}
          label="Video"
          validationText=""
          value={value}
          onChange={onChange}
          type="video"
          icon={faVideo as any}
          errorMsg={error?.message}
          optional
        >
          <ul className="text-black list-none text-center text-h12">
            <li>Max 90 seconds</li>
            <li>Max 100MB</li>
          </ul>
        </LandingMediaDropbox>
      )}
    />
  );

  const secondCol = (
    <>
      <div>
        <TwoColumns first={coverImageInput} second={introVideoInput} />
        <div className="mt-4">
          <SelectImageSideInput index={index} />
        </div>
      </div>
    </>
  );

  return <TwoColumns first={firstCol} second={secondCol} />;
}
